// Resume42.js
import React from 'react';

const Resume42 = ({ color = "#5d4037" }) => {
  return (
    <div 
      style={{
        width: '210mm',
        minHeight: '297mm',
        backgroundColor: '#f9f5f2',           // soft peach / beige
        color: '#2d2d2d',
        fontFamily: 'Arial, Helvetica, sans-serif',
        display: 'flex',
        margin: '0 auto',
        boxShadow: '0 0 20px rgba(0,0,0,0.1)',
        overflow: 'hidden'
      }}
    >
      {/* LEFT COLUMN - Profile photo + short bio + contact */}
      <div 
        style={{
          width: '38%',
          backgroundColor: '#f5e9e1',         // slightly darker peach
          padding: '40px 30px',
          display: 'flex',
          flexDirection: 'column',
          gap: '35px'
        }}
      >
        {/* Photo - added subtle colored border */}
        <div>
          <img 
            src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&auto=format&fit=crop&w=987&q=80" 
            alt="Greta Mae Evans"
            style={{
              width: '100%',
              height: 'auto',
              borderRadius: '8px',
              marginBottom: '20px',
              border: `4px solid ${color}`,
              boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
            }}
          />
        </div>

        {/* PROFILE */}
        <div>
          <h3 style={{ 
            fontSize: '1.1rem', 
            fontWeight: 'bold', 
            marginBottom: '12px',
            color: color,
            textTransform: 'uppercase',
            letterSpacing: '1px'
          }}>
            PROFILE
          </h3>
          <p style={{ 
            fontSize: '0.95rem', 
            lineHeight: '1.5',
            color: '#444'
          }}>
            Business Administration student. I consider myself a responsible and orderly person. I am looking forward to my first work experience.
          </p>
        </div>

        {/* CONTACT ME */}
        <div>
          <h3 style={{ 
            fontSize: '1.1rem', 
            fontWeight: 'bold', 
            marginBottom: '16px',
            color: color,
            textTransform: 'uppercase',
            letterSpacing: '1px'
          }}>
            CONTACT ME
          </h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', fontSize: '0.95rem' }}>
            <div>📞 123-456-7890</div>
            <div>✉️ hello@reallygreatsite.com</div>
            <div>📍 123 Anywhere St., Any city</div>
          </div>
        </div>
      </div>

      {/* RIGHT COLUMN - Main content */}
      <div 
        style={{
          width: '62%',
          padding: '50px 40px',
          backgroundColor: '#fff',
          display: 'flex',
          flexDirection: 'column',
          gap: '35px'
        }}
      >
        {/* Name & Title */}
        <div>
          <h1 style={{ 
            fontSize: '2.4rem', 
            fontWeight: 'bold', 
            margin: '0',
            lineHeight: '1.1',
            color: '#3e2723'
          }}>
            GRETA MAE<br/>EVANS
          </h1>
          <p style={{ 
            fontSize: '1.3rem', 
            margin: '8px 0 0 0',
            color: color,               // changed to dynamic color
            fontWeight: '500'
          }}>
            Student
          </p>
        </div>

        {/* EDUCATION */}
        <div>
          <h2 style={{ 
            fontSize: '1.35rem', 
            fontWeight: 'bold', 
            marginBottom: '16px',
            color: color,
            textTransform: 'uppercase',
            letterSpacing: '1.5px',
            borderBottom: `2px solid ${color}44`,  // semi-transparent version
            paddingBottom: '6px'
          }}>
            EDUCATION
          </h2>
          
          <div style={{ marginBottom: '24px' }}>
            <h3 style={{ fontSize: '1.1rem', margin: '0', fontWeight: 'bold', color: '#333' }}>
              BORCELLE UNIVERSITY
            </h3>
            <p style={{ margin: '4px 0', color: '#555', fontSize: '0.95rem' }}>
              2020–2024 • Business Administration career, in progress
            </p>
          </div>

          <div>
            <h3 style={{ fontSize: '1.1rem', margin: '0', fontWeight: 'bold', color: '#333' }}>
              BORCELLE SCHOOL
            </h3>
            <p style={{ margin: '4px 0', color: '#555', fontSize: '0.95rem' }}>
              2015–2019 • High school Diploma
            </p>
          </div>
        </div>

        {/* LANGUAGE */}
        <div>
          <h2 style={{ 
            fontSize: '1.35rem', 
            fontWeight: 'bold', 
            marginBottom: '16px',
            color: color,
            textTransform: 'uppercase',
            letterSpacing: '1.5px',
            borderBottom: `2px solid ${color}44`,
            paddingBottom: '6px'
          }}>
            LANGUAGE
          </h2>
          <ul style={{ paddingLeft: '20px', margin: '0', fontSize: '0.98rem', lineHeight: '1.6' }}>
            <li>Native English</li>
            <li>Advanced Spanish</li>
          </ul>
        </div>

        {/* COMPUTER SKILLS */}
        <div>
          <h2 style={{ 
            fontSize: '1.35rem', 
            fontWeight: 'bold', 
            marginBottom: '16px',
            color: color,
            textTransform: 'uppercase',
            letterSpacing: '1.5px',
            borderBottom: `2px solid ${color}44`,
            paddingBottom: '6px'
          }}>
            COMPUTER SKILLS
          </h2>
          <ul style={{ paddingLeft: '20px', margin: '0', fontSize: '0.98rem', lineHeight: '1.6' }}>
            <li>Text processor</li>
            <li>Spreadsheet</li>
            <li>Slide presentation</li>
          </ul>
        </div>

        {/* VOLUNTEER EXPERIENCE */}
        <div>
          <h2 style={{ 
            fontSize: '1.35rem', 
            fontWeight: 'bold', 
            marginBottom: '16px',
            color: color,
            textTransform: 'uppercase',
            letterSpacing: '1.5px',
            borderBottom: `2px solid ${color}44`,
            paddingBottom: '6px'
          }}>
            VOLUNTEER EXPERIENCE
          </h2>
          
          <div>
            <h3 style={{ fontSize: '1.1rem', margin: '0', fontWeight: 'bold', color: '#333' }}>
              INGOUDE COMPANY
            </h3>
            <p style={{ margin: '4px 0', color: '#555', fontSize: '0.95rem' }}>
              2024 – present
            </p>
            <p style={{ margin: '8px 0 0 0', lineHeight: '1.5' }}>
              Participation in collections to distribute in low-income schools.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export const resumeMeta = {
  hasPhoto: true,           // now showing photo in left column
  columns: 2,
  colorOptions: [
    { value: "#4527a0", label: "Deep Purple" },
    { value: "#00695c", label: "Deep Teal" },
    { value: "#d84315", label: "Fiery Orange" },
    { value: "#5d4037", label: "Warm Brown" },
    { value: "#0277bd", label: "Strong Blue" }
  ]
};

export default Resume42;